import { defineStore } from "pinia";
import { ref } from "vue";

export const useAffiliateInvoiceStore = defineStore('useAffiliateInvoiceStore', () => {
    const isNeedUpdateInvoice = ref<boolean>(false);

    return { isNeedUpdateInvoice };
});
